import React from 'react';
import { useProperty } from '~/properties';

const PropertyHeader = props => {

    const { data: property } = useProperty(props.property_id);

    return (
        <div style={{
            textAlign: 'center',
            paddingTop: '20px'
        }}>
            {property && <h3>{property.name}</h3>}
        </div>
    );
};

export default PropertyHeader;
